import { css } from 'styled-components';

export const contentWidthMedia = (width) => {
    return {
        lessThan: (breakpoint, styles) =>
            width <= breakpoint
                ? css`
                      ${styles};
                  `
                : '',
        greaterThan: (breakpoint, styles) =>
            width >= breakpoint
                ? css`
                      ${styles};
                  `
                : '',
        between: (min, max, styles) =>
            width >= min && width <= max
                ? css`
                      ${styles};
                  `
                : '',
    };
};

export const livePageResponsiveWithSidebar = (isLeftSideBarOpen, styles) => css`
    ${isLeftSideBarOpen &&
        css`
            @media screen and (max-width: 1600px) {
                ${styles};
            }
        `};

    @media screen and (max-width: 1440px) {
        ${styles};
    }
`;
